// Application constants and configuration

export const ISSUE_STATUS = {
  TODO: 'todo',
  IN_PROGRESS: 'in-progress',
  IN_REVIEW: 'in-review',
  DONE: 'done'
};

export const ISSUE_PRIORITY = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
  CRITICAL: 'critical'
};

export const ISSUE_TYPE = {
  STORY: 'story',
  TASK: 'task',
  BUG: 'bug',
  EPIC: 'epic'
};

export const SPRINT_STATUS = {
  PLANNED: 'planned',
  ACTIVE: 'active',
  COMPLETED: 'completed'
};

export const USER_ROLES = {
  ADMIN: 'admin',
  MANAGER: 'manager',
  USER: 'user'
};

export const STATUS_OPTIONS = [
  { value: ISSUE_STATUS.TODO, label: 'To Do', color: 'gray' },
  { value: ISSUE_STATUS.IN_PROGRESS, label: 'In Progress', color: 'blue' },
  { value: ISSUE_STATUS.IN_REVIEW, label: 'In Review', color: 'yellow' },
  { value: ISSUE_STATUS.DONE, label: 'Done', color: 'green' }
];

export const PRIORITY_OPTIONS = [
  { value: ISSUE_PRIORITY.LOW, label: 'Low', color: 'green' },
  { value: ISSUE_PRIORITY.MEDIUM, label: 'Medium', color: 'yellow' },
  { value: ISSUE_PRIORITY.HIGH, label: 'High', color: 'orange' },
  { value: ISSUE_PRIORITY.CRITICAL, label: 'Critical', color: 'red' }
];

export const TYPE_OPTIONS = [
  { value: ISSUE_TYPE.STORY, label: 'Story' },
  { value: ISSUE_TYPE.TASK, label: 'Task' },
  { value: ISSUE_TYPE.BUG, label: 'Bug' },
  { value: ISSUE_TYPE.EPIC, label: 'Epic' }
];

export const ROLE_OPTIONS = [
  { value: USER_ROLES.USER, label: 'User' },
  { value: USER_ROLES.MANAGER, label: 'Manager' },
  { value: USER_ROLES.ADMIN, label: 'Admin' }
];

// Color mappings for UI
export const STATUS_COLORS = {
  [ISSUE_STATUS.TODO]: 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-300',
  [ISSUE_STATUS.IN_PROGRESS]: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300',
  [ISSUE_STATUS.IN_REVIEW]: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300',
  [ISSUE_STATUS.DONE]: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300'
};

export const PRIORITY_COLORS = {
  [ISSUE_PRIORITY.LOW]: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
  [ISSUE_PRIORITY.MEDIUM]: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300',
  [ISSUE_PRIORITY.HIGH]: 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-300',
  [ISSUE_PRIORITY.CRITICAL]: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300'
};

// Local storage keys
export const STORAGE_KEYS = {
  THEME: 'theme',
  USER_PREFERENCES: 'user_preferences',
  RECENT_PROJECTS: 'recent_projects'
};

// Default configuration
export const DEFAULT_CONFIG = {
  PAGE_SIZE: 20,
  MAX_FILE_SIZE: 5 * 1024 * 1024, // 5MB
  ALLOWED_FILE_TYPES: ['image/jpeg', 'image/png', 'image/gif'],
  SESSION_TIMEOUT: 24 * 60 * 60 * 1000 // 24 hours
};

// Feature flags
export const FEATURE_FLAGS = {
  ENABLE_ANALYTICS: true,
  ENABLE_NOTIFICATIONS: true,
  ENABLE_FILE_UPLOAD: true,
  ENABLE_ADVANCED_REPORTS: true
};